/** Protected Base coordinators append the proof-bound encrypted output transcript. */
export const RECOVERY_RECORDS_ABI =
  "(address pool,uint8 kind,bytes32 locator,bytes envelope)[]";
export const BASE_RECOVERY_ARGUMENT = process.env
  .REACT_APP_BASE_RECOVERY_REGISTRY
  ? `,${RECOVERY_RECORDS_ABI} recoveryRecords`
  : "";
export const BASE_RECOVERY_TOKEN_ARGUMENTS = process.env
  .REACT_APP_BASE_RECOVERY_REGISTRY
  ? `,${RECOVERY_RECORDS_ABI} tokenRecords,${RECOVERY_RECORDS_ABI} gasRecords`
  : "";
